export default "/_next/static/chunks/fonts/S6uyw4BMUTPHjxAwXjeu-b267ec5ad7d86fe2e606e091bcde775a.woff2";